import { connect } from 'react-redux'
import App from './App'
import {state_update,state_force_update, state_load_json } from './actions'
import {
  CHARM_9000,CHARM_ZSKU
} from './constants';

function getRealS(s,zsku,state){
 //console.log('in cat_sku_s=1',s,zsku,state) 
  var h2list=CHARM_9000
  
  var cat_s =''
  var zsku1 =''
 // console.log('in=3',state) 
  if (CHARM_ZSKU.hasOwnProperty(zsku)) {
    s= CHARM_ZSKU[zsku]
   
    zsku1=s
  }
  //console.log('in cat_sku_s=2',s,zsku,state) 
  if (s==='9000')
   return ['-','9000',zsku1]
  var sku_s=s
    
  if (s ==='9300')
  //cat_s ='0'
  return ['0','9300','9000']
  var ii2,ii2a
    for (ii2 in h2list )
   {
   // console.log('ii2=',ii2,h2list[ii2]) 
    for (ii2a in h2list[ii2] )
    {
      if (h2list[ii2][ii2a] === s){
    //    console.log('ii2=',ii2,h2list[ii2][ii2a]) 
        sku_s=h2list[ii2][ii2a]
        cat_s = ii2
        //state['s'] =sku_s
        //break
        return [cat_s,sku_s,'']
      }
      //h2all.push(h2list[ii2][ii2a])
    }
    if (cat_s !== '')
    break
   }
   return [cat_s,sku_s,zsku1]
  }

const mapStateToProps = (state, ownProps) => {
  var cat_sku_s =getRealS(state['s'],state['zsku'],state)
   //    console.log('cat_sku_s=',cat_sku_s) 
  //if (cat_sku_s[2] !=='')
  //  state['s'] =cat_sku_s[1]
 //   console.log('state s',state.s,cat_sku_s) 
  return {
  initAttr: state.hasOwnProperty('init')? state['init']: false,
  initValue: state.hasOwnProperty('init')? state[state['init']]: false,
//  initValue: state[state['init']],
  loading: state['loading'],
  json: state['json'],
  s:cat_sku_s[1],
  sku_s: cat_sku_s[1],
  cat_s: cat_sku_s[0],
  zsku: state['zsku'],
  cfg: state['cfg'],
  test: state['test'],
  hc: state['hc'],
  hs: state['hs'],
  he: state['he'],
  hu: state['hu'],
  push_message:state['message'],
  lifestyle:state['lifestyle'], 
  lsbefore: state['lsbefore'],
  lsafter: state['lsafter'],
  orientation: state.orientation
}}


 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onLoad: ( (attr,value) => dispatch(state_force_update({attr:attr,value:value}))),
  onImage: ( (value) => dispatch(state_update({attr:'active_view',value:value}))),
  onUpdate: ( (attr,value) => dispatch(state_update({attr:attr,value:value}))),
  onRemoveMessage: ( () => dispatch(state_update({attr:'message',value:''}))),
  onJson: ( (value) => dispatch(state_load_json(value)))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)


// WEBPACK FOOTER //
// ./src/AppWrap.js